import * as yup from "yup";

export const hearingDatesSchema = yup.object({
  comment: yup.string().max(255, "Maximum 255 characters"),
});
